module.exports = __webpack_public_path__ + "static/media/loading.c66df858.svg";